import { selectedDay as Props } from "../../../types/calendar";
import useTranslation, { useRoutes } from "../../../helpers/translationTexts/useTranslation";
import Router from "next/router";
import { PlayNowButton } from "./ButtonPlayNow.components";

const ButtonPlayNow: React.FC<Props> = ({ selectedDay }) => {
  const routerPlayDailySudoku = useRoutes().PlayDailySudoku;
  const selectDate = new Date(selectedDay);
  const queryInfo = {
    month: (selectDate.getMonth() + 1).toString(),
    day: selectDate.getDate().toString(),
    year: selectDate.getFullYear().toString(),
  };

  if (queryInfo.month.length === 1) {
    queryInfo.month = `0${queryInfo.month}`;
  }
  if (queryInfo.day.length === 1) {
    queryInfo.day = `0${queryInfo.day}`;
  }

  const onPlayNowClick = () => {
    const url = routerPlayDailySudoku + `?date=${queryInfo.year}-${queryInfo.month}-${queryInfo.day}`;
    Router.push(url);
  };

  const PlayNowText = useTranslation("playNow");

  return <PlayNowButton title={PlayNowText} onClick={onPlayNowClick} />;
};

export default ButtonPlayNow;
